<template>
  <div id="orderlist">
    <el-row style="margin-top:20px">
      <el-col>
        <el-button size="medium" @click="addLine">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="项目点名称" prop="NAME"></el-table-column>
          <el-table-column label="操作" min-width="30px">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="$_removeLine(scope.row)">解除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增匹配关系" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small">
        <el-form-item label="项目点：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.PROJECT" @change="getProjectId" clearable style="width:100%">
            <el-option v-for="item in projectList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              <span style="float: left">{{ item.AB_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="$_submitMatch()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getLineSetDetail, getProjectList, submitMatch, removeLine,
} from 'api/systemSetting';

export default {
  data() {
    return {
      // loading:false,
      tableData: [],
      addFormVisible: false,
      addForm: {},
      projectList: [],
      formLabelWidth: '100px',
      PROJECT_ID: 0,
    };
  },
  created() {
    this.$_getLineSetDetail();
  },
  methods: {
    // 获取匹配项目点的信息
    $_getLineSetDetail() {
      const data = {
        LINE_ID: this.$route.params.id,
      };
      getLineSetDetail(data).then((res) => {
        this.tableData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取未匹配的项目点
    $_getProjectList() {
      getProjectList().then((res) => {
        this.projectList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 点击新增
    addLine() {
      this.addFormVisible = true;
      this.$_getProjectList();
    },
    // 点击模态框取消
    close() {
      this.addFormVisible = false;
      this.addForm.PROJECT = '';
    },
    // 获取项目点ID
    getProjectId(e) {
      this.PROJECT_ID = e;
    },
    // 提交匹配关系
    $_submitMatch() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            LINE_ID: this.$route.params.id,
            PROJECT_ID: this.PROJECT_ID,
          };
          if (!this.addForm.PROJECT) {
            this.$message.show({ text: '请选择项目点', type: 'warning' });
            return false;
          }
          submitMatch(data).then((res) => {
            this.$message.show({ text: '匹配成功', type: 'success' });
            this.addFormVisible = false;
            this.$_getLineSetDetail();
            this.addForm.PROJECT = '';
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 解除匹配关系
    $_removeLine(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            LINE_ID: this.$route.params.id,
            PROJECT_ID: row.PROJECT_ID,
          };
          removeLine(data).then((res) => {
            this.$message.show({ text: '解除成功', type: 'success' });
            this.$_getLineSetDetail();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/lineSetDetail.vue